import { render, staticRenderFns } from "./ApplicantEditPersonalData.vue?vue&type=template&id=a2fc9cea&"
import script from "./ApplicantEditPersonalData.vue?vue&type=script&lang=js&"
export * from "./ApplicantEditPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports